module.exports = __webpack_public_path__ + "img/card-img_2(768).9482d2bf.png";